/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/react';

const VerificationInput = ({
  length = 6,
  onChange = () => {},
  middleBreak = false,
}) => {
  const [code, setCode] = useState(Array(length).fill(''));
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current = inputRefs.current.slice(0, length);
  }, [length]);

  useEffect(() => {
    onChange(code.join(''));
  }, [code, onChange]);

  const handleChange = (index, value) => {
    if (value && !/^\d+$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, length);
    const numbers = pastedData.split('').filter((char) => /^\d+$/.test(char));

    const newCode = [...code];
    numbers.forEach((num, index) => {
      if (index < length) newCode[index] = num;
    });
    setCode(newCode);
  };

  return (
    <div
      css={css`
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
      `}
    >
      {code.map((digit, index) => (
        <React.Fragment key={index}>
          {middleBreak && index === length / 2 && (
            <div
              key="break"
              css={css`
                width: 8px;
                border: 1px solid rgba(0, 0, 0, 0.23);
              `}
            />
          )}
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            css={css`
              width: 48px;
              height: 48px;
              padding: 0;
              font-size: 20px;
              text-align: center;
              border: 1px solid rgba(0, 0, 0, 0.23);
              border-radius: 8px;
              outline: none;
              transition: all 0.2s ease;
              &:focus: {
                border-color: #3b82f6;
                box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
              }
              ,
              @media (max-width: 640px): {
                width: 40px;
                height: 40px;
                font-size: 18px;
              }
            `}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default VerificationInput;
